// extracted by mini-css-extract-plugin
module.exports = {"printable":"styles_base_printable__HUrZm","nonPrintable":"styles_base_nonPrintable__wMZEK","logo":"styles_base_logo__Misqx"};